import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';

let titleSceneG: any = null;
const G = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneG) {
                    AniContainer.removeScene(titleSceneG);
                    titleSceneG = null;
                }

                titleSceneG = AniContainer.create({
                    triggerElement: '.dpu-detail-G .dpu-G-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneG) {
                    AniContainer.removeScene(titleSceneG);
                    titleSceneG = null;
                }
            };
        }
    }, []);
    return (
        <section className={`dpu-detail-G dpu-detail-section ${styles.dpuDetailG}`}>
            <div className={`dpu-G-box ${textEnter ? 'enter' : ''}`}>
                <p className='title'>{t('secG2_title')}</p>
                <p className='desc'>{t('secG2_desc')}</p>
            </div>
        </section>
    );
};

export default G;
